const defaultDirection = document.documentElement.dir === 'rtl' ? 'rtl' : 'ltr';

class SplideComponent extends HTMLElement {
  constructor() {
    super();
    this.sliderContainer = this.querySelector('.splide');
    document.addEventListener('shopify:section:load', () => { this.initSlider(); });
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    if (!this.sliderContainer || !window.Splide) return;
    if (this._splideInstance) {
      this._splideInstance.destroy();
      this._splideInstance = null;
    }

    const slidesDesktop = parseInt(this.dataset.slidesDesktop) || 3;
    const slidesMobile  = parseInt(this.dataset.slidesMobile)  || 1;
    const gapDesktop    = parseInt(this.dataset.gapDesktop)    || 30;
    const gapMobile     = parseInt(this.dataset.gapMobile)     || 15;
    const type          = this.dataset.type || 'slide';
    const autoplay      = this.dataset.autoplay === 'true';
    const interval      = parseInt(this.dataset.autoplaySpeed) * 1000 || 5000;
    const arrows        = this.dataset.arrows !== 'false';
    const pagination    = this.dataset.pagination !== 'false';
    const destroyDesktop = this.dataset.destroyDesktop === 'true';
    const destroyMobile  = this.dataset.destroyMobile  === 'true';
    const sidePaddingDesktop = parseInt(this.dataset.sidePaddingDesktop) || 0;
    const sidePaddingMobile  = parseInt(this.dataset.sidePaddingMobile)  || 15;
    const arrowsColor = this.dataset.arrowsColor ? ` color-${this.dataset.arrowsColor}` : '';
    const dotsColor   = this.dataset.dotsColor   ? ` color-${this.dataset.dotsColor} dots-custom-color` : '';

    const config = {
      type,
      direction: defaultDirection,
      rewind: type === 'fade',
      autoplay,
      interval,
      drag: true,
      arrows,
      pagination,
      perPage: slidesDesktop,
      perMove: parseInt(this.dataset.perMoveDesktop) || 1,
      gap: gapDesktop,
      padding: { left: sidePaddingDesktop, right: sidePaddingDesktop },
      destroy: destroyDesktop,
      classes: {
        arrow: `splide__arrow${arrowsColor}`,
        page:  `splide__pagination__page${dotsColor}`,
      },
      easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
      breakpoints: {
        749: {
          type,
          perPage: slidesMobile,
          perMove: parseInt(this.dataset.perMoveMobile) || 1,
          gap: gapMobile,
          padding: { left: sidePaddingMobile, right: sidePaddingMobile },
          destroy: destroyMobile,
        }
      }
    };

    this._splideInstance = new Splide(this.sliderContainer, config);
    this._splideInstance.mount();
  }
}

customElements.define('splide-component', SplideComponent);
